export default {
  card: {
    title: 'Pagar con tarjeta',
    inputs: {
      number: {
        title: 'Número de tarjeta',
        placeholder: 'Introduzca el número de tarjeta',
      },
      cvc: {
        title: 'CVC',
        placeholder: 'CVC',
      },
      expiry: {
        title: 'MM/AA',
        placeholder: 'MM/AA',
      },
    },
  },
  'driver-tips': {
    title: 'Gracias por<br><span>apoyando a los conductores!</span>',
    description: 'El 100% de tu propina va directamente a',
    remember: 'Recuerde que dejar propina depende exclusivamente de usted.',
    'confirmation-modal': {
      title: 'Por favor confirme:',
      description: '¿Estás seguro de que quieres enviar un consejo de',
      error: 'El monto de la propina debe estar entre $2 y $40.',
      actions: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
    },
  },
  'tips-amount': {
    other: 'Otro',
  },
  'tips-component': {
    thanks: '¡Gracias! Su propina ha sido recibida y seguramente alegrará el día del conductor.',
    more: 'Envía más consejos',
  },
  'tips-old': {
    title: 'Gracias por<br><span>apoyando a los conductores!</span>',
    description: 'El 100% de tu propina va directamente a',
    btn: 'Tarjeta de pago',
  },
}
